<template>
  <base-tutorial :steps="steps">
    <div>
      <h2>
        Olá! Nesta etapa vamos normalizar as responsabilidades, bem como os
        níveis de impacto, dificuldade e as competências técnicas cadastradas.
      </h2>
    </div>

    <div>
      <h2>
        Na aba “Competências” você encontra os filtros: “Unidade(s)”:
        selecione a(s) unidade(s) com a(s) qual(is) você trabalhará nesta aba.
        Após selecionada(s), é possível visualizar todas as competências
        associadas as responsabilidades cadastradas pelos gestores dessa(s)
        unidade(s). “Situação”: neste filtro você pode visualizar “todas”;
        “competências gerais” e “competências inseridas”. “Pesquisar”:
        possibilita a busca por qualquer termo cadastrado.
      </h2>
    </div>

    <div>
      <h2>
        No filtro “Unidades”, sugere-se selecionar “todas” e no filtro “Situação”,
        sugere-se selecionar “competências inseridas”. O sistema, então, apresentará
        a tabela com as “Competências técnicas”. Inicialmente, sugere-se observar se
        há alguma competência que não está associada a nenhuma responsabilidade, ou
        seja, apresenta o ícone “engrenagem” zerado. Neste caso, realiza-se a exclusão
        da competência clicando no ícone “lixeira”. Na coluna “Competências”, deve-se
        observar termos idênticos ou semelhantes e selecioná-los para agrupamento em
        uma única competência técnica, visando padronizar o texto, sintetizar e evitar
        redundâncias. Na coluna “Responsabilidades”, ao clicar no ícone “engrenagem”,
        pode-se observar as unidades e suas responsabilidades relacionadas a cada
        competência. Na última coluna, é possível visualizar o ícone “lápis”, que
        permite realizar a edição no texto da competência. No ícone “lixeira”, você
        pode excluir a Competência.
      </h2>
    </div>

    <div>
      <h2>
        Na aba “Responsabilidades”, você encontra os filtros: “Unidade(s)”: selecione
        a(s) unidade(s) com a(s) qual(is) você trabalhará nesta aba. Após selecionada(s),
        é possível visualizar todas as responsabilidades cadastradas pelos gestores
        dessa(s) unidade(s). “Situação”: neste filtro você pode visualizar “todas”;
        “arquivadas”; “normalizadas” e “não normalizadas”. “Pesquisar”: possibilita a
        busca por qualquer termo cadastrado. “Ordenar por”: organiza as responsabilidades
        de acordo com o grau de dificuldade; o grau de impacto; a responsabilidade; o
        número de competências e a unidade. Ainda é possível organizar em ordem alfabética
        ou crescente e decrescente, utilizando a seta.
      </h2>
    </div>

    <div>
      <h2>
        No filtro “Unidade”, selecione apenas uma unidade para visualizar as responsabilidades.
        No filtro “Situação”, selecione a opção “Não normalizadas”. Realizadas a seleção
        de unidade e situação, deve-se clicar no botão “Baixar XLS”, onde é possível obter
        a lista das responsabilidades cadastradas na unidade selecionada. Com essa lista, você
        fará a normalização prévia das responsabilidades de cada unidade. A normalização prévia
        consiste em observar se a responsabilidade está escrita com verbo no infinitivo acrescida
        de complemento, que explica o que faz a unidade considerando sua missão. Caso a composição
        (verbo no infinitivo + complemento) esteja adequada, não há necessidade de edição. Caso
        contrário, realize os ajustes necessários, indicando correções no texto ou agrupando as
        responsabilidades.
      </h2>
    </div>

    <div>
      <h2>
        Ao agrupar diferentes responsabilidades cadastradas, inclua na edição o termo “X – sugestão
        arquivar, texto contemplado em:” e insira o novo texto da responsabilidade agrupada, para indicar
        ao gestor validador a alteração realizada. Após a normalização prévia, realizada na planilha
        XLS, reescreva, no sistema, o texto das responsabilidades revisadas, bem como as
        responsabilidades a serem arquivadas. Observe que o sistema destaca em amarelo os campos que
        foram alterados. Selecione todas as responsabilidades da unidade, incluindo aquelas que deverão
        ser arquivadas pelo gestor validador, clique no botão “Normalizar” e, posteriormente, no “Finalizar”.
      </h2>
    </div>

    <div>
      <h2>Importante!</h2>
      <h2>
        Verifique se, após o agrupamento de responsabilidades, há necessidade de incorporar competências
        técnicas na responsabilidade reescrita para contemplar o conjunto de competências necessárias a
        realização da responsabilidade. Além disso, verifique também os níveis de impacto e dificuldade
        das responsabilidades agrupadas para manter aquelas que tem maiores níveis, caso sejam divergentes.
        Ao final, é relevante observar se todas as responsabilidades foram revisadas de acordo com a
        composição (verbo no infinitivo + complemento). Selecione todas as responsabilidades
        cadastradas e clique no botão “Normalizar” e, em seguida, no botão “Finalizar”, consolidando o
        mapeamento técnico. É possível, dentro do prazo estabelecido para a normalização técnica, reverter
        esta ação, caso necessário editar uma responsabilidade. Lembre-se de normalizá-la novamente e
        finalizar a ação.
      </h2>
    </div>
  </base-tutorial>
</template>

<script>
import BaseTutorial from '../BaseTutorial';

export default {
  name: 'TutorialNormalizacaoResponsabilidade',

  components: { BaseTutorial },

  data() {
    return {
      steps: ['Introdução', 'Competências', ' Normalização das Competências Técnicas',
        'Aba “Responsabilidades”', 'Normalização de Responsabilidades',
        'Normalização de Responsabilidades', 'Importante!'],
    };
  },
};
</script>
